import React, { useCallback, useRef } from 'react';
import Filter from '@/pages/dashboard/components/NewFilter';
import moment from 'moment';
import { setBtnPointLog , formatFilterValues } from "@/pages/dashboard/utils/utils";
import { shallowEqual, useSelector } from 'umi';

// 筛选器路径
const FILTER_PATH = 'realtime/steamCCU';

/**
 *
 * @param props
 * @param props:filterConfirm 筛选器确认函数
 * @param props:filterReset 筛选器重置函数
 * @param props:filterInit 初始化函数，会向外部传递初始化后的筛选器值
 * @returns
 */

const RealtimeSteamCCUFilter = (props: any) => {
  const { filterConfirm, filterReset, filterInit, buttonLogConfig, openSticky = false, children, isHaveFilterSave = true,timeZone=0 } = props;
  const filterValueRef = useRef<any>(null); // 筛选器值，此处不用state，更新formValue同样会触发组件更新
  // 获取游戏配置发布时间
  const { releaseTime } = useSelector((state: any) => ({
    releaseTime: state?.dashboardSetting?.gameConfig?.game_phase_timeline?.release_time,
  }), shallowEqual);
  // 设置inputList
  const inputList = [
    {
      type: 'singleDaily',
      key: 'singleDaily',
      default: moment().utcOffset(timeZone).format('YYYY-MM-DD'), // 根据时区设置默认值
    },
    {
      type: 'contrastDaily',
      key: 'contrastDaily',
      default: moment().utcOffset(timeZone).subtract(7, 'day').format('YYYY-MM-DD'),
      alias: 'contrastDaily1'
    },
    {
      type: 'contrastDaily2',
      key: 'contrastDaily2',
      default: moment(releaseTime).format('YYYY-MM-DD'),
      alias: 'contrastDaily2'
    },
  ];

  const checkDateChange = (value: any, inputList: any) => {
    const singleDaily = inputList.find((item: any) => item?.key === 'singleDaily');
    const contrastDaily = inputList.find((item: any) => item?.key === 'contrastDaily');
    const contrastDaily2 = inputList.find((item: any) => item?.key === 'contrastDaily2');
    
    return value?.singleDaily !== singleDaily?.default || value?.contrastDaily !== contrastDaily?.default || value?.contrastDaily2 !== contrastDaily2?.default;
  };

  // 私有化处理，抹平新旧筛选器的差距
  const onInit = useCallback((value: any, inputList: any) => {
    filterValueRef.current = value;
    // todo 锁定状态下如果锁定时间跟默认时间相同，是否需要单独处理，设置diff为false？
    filterInit({
      ...formatFilterValues(value),
      timeDiff: checkDateChange(value, inputList),
    });
  }, [filterInit]);

  const onConfirm = useCallback((value: any, inputList: any) => {
    filterValueRef.current = value;
    const obj: any = {
      ...formatFilterValues(value),
      timeDiff: checkDateChange(value, inputList),
    };

    filterConfirm(obj);
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, obj);
  }, [filterConfirm]);

  const onReset = useCallback((value: any) => {
    filterValueRef.current = value;
    const obj = {
      ...formatFilterValues(value),
      timeDiff: false
    };
    filterReset(obj);
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, obj, true);
  }, [filterReset]);

  return <Filter
    // pc_inflexion的realtime revenue页面，不做筛选器保存功能
    isHaveFilterSave ={isHaveFilterSave}
    openSticky={openSticky}
    path={FILTER_PATH}
    latestDateType={''}
    value={filterValueRef.current}
    inputList={inputList}
    onInit={onInit}
    onConfirm={onConfirm}
    onReset={onReset}
  >
    {children}
  </Filter>;
};

export default RealtimeSteamCCUFilter;
